import { getStorage } from '@/utils/storage'
export default {
  state: {
    birthday: null,
    cityCode: null,
    gender: null,
    headUrl: null,
    nickname: '',
    phone: '',
    processedPhone: '',
    userId: '',
    vipExpiredDate: '',
    getVip: false,
    hasGetInfo: false // 是否已获取信息
  },
  getters: {},
  mutations: {
    setUserId (state, userId) {
      state.userId = userId
    },
    setVipExpiredDate (state, vipExpiredDate) {
      state.vipExpiredDate = vipExpiredDate
    },
    setGetVip (state, getVip) {
      state.getVip = getVip
    },
    setPhone (state, phone) {
      state.phone = phone
      if (phone) {
        state.processedPhone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      } else {
        state.processedPhone = phone
      }
    },
    setNickname (state, nickname) {
      state.nickname = nickname
    },
    setHeadUrl (state, headUrl) {
      state.headUrl = headUrl
    },
    setGender (state, gender) {
      state.gender = gender
    },
    setCityCode (state, cityCode) {
      state.cityCode = cityCode
    },
    setBirthday (state, birthday) {
      state.birthday = birthday
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    }
  },
  actions: {
    setUserInfo: async function ({ commit }, userInfo) {
      let fromStorage = false
      if (!userInfo) {
        userInfo = getStorage()
        fromStorage = true
      }
      if (userInfo && userInfo.userId) {
        commit('setUserId', userInfo.userId)
        commit('setPhone', userInfo.phone)
        commit('setNickname', userInfo.nickname)
        commit('setHeadUrl', userInfo.headUrl)
        commit('setGender', userInfo.gender)
        commit('setCityCode', userInfo.cityCode)
        commit('setBirthday', userInfo.birthday)
        userInfo.vipExpiredDate !== null && commit('setVipExpiredDate', userInfo.vipExpiredDate)
        commit('setGetVip', !fromStorage)
      }
      commit('setHasGetInfo', true)
    },
    logOut: function ({ commit }) {
      commit('setUserId', '')
      commit('setPhone', '')
      commit('setNickname', '')
      commit('setHeadUrl', null)
      commit('setGender', null)
      commit('setCityCode', null)
      commit('setBirthday', null)
      commit('setVipExpiredDate', '')
      commit('setGetVip', false)
      commit('setHasGetInfo', false)
    }
  }
}
